module.exports = __webpack_public_path__ + "static/media/14UNEP3.366ed213.jpg";